/**
 * リンクフォーカス時の青枠を消すjs
 * add remove focus blur event
 */

const onFocusBlur = () => $(document).on('click focus', 'a, button', e => $(e.currentTarget).blur());
export default onFocusBlur;



// WEBPACK FOOTER //
// ./src/scripts/common/onFocusBlur.js